import { useCallback } from 'react';
import type { GoodsOption } from 'shared/src/api';
import { bridge } from 'shared/src/utils';
import { useAddToCart } from '../queries/useAddToCart';
import { useLogClickAddToCart } from './useLogClickAddToCart';
import { ApiError } from 'shared/src/api/httpClient';
import { systemAlert } from 'shared/src/component';
import { usePreloadGoodsRecommend } from './usePreloadGoodsRecommend';

export const useOnPressAddToCart = ({
  selected,
  onCompleteAddToCart,
}: {
  selected: GoodsOption[];
  onCompleteAddToCart: () => void;
}) => {
  const { mutateAsync: addToCart, isPending: loadingAddToCart } =
    useAddToCart(selected);
  const logClickAddToCart = useLogClickAddToCart({ selected });
  const preloadGoodsRecommend = usePreloadGoodsRecommend();

  const onPressAddToCart = useCallback(
    async (isForce = false) => {
      if (!isForce) {
        logClickAddToCart();
      }
      preloadGoodsRecommend();
      try {
        await addToCart({ isForce });
        bridge.updateMemberMe(JSON.stringify({ refetch: false }));
        onCompleteAddToCart();
      } catch (ex) {
        if (ex instanceof ApiError && ex.code === 12) {
          systemAlert('', ex.message, [
            { text: '취소', style: 'cancel' },
            { text: '확인', onPress: () => onPressAddToCart(true) },
          ]);
        } else {
          const error = ex as Error;
          bridge.toast(error.message);
        }
      }
    },
    [addToCart, logClickAddToCart, onCompleteAddToCart, preloadGoodsRecommend],
  );

  return { onPressAddToCart, loadingAddToCart };
};
